import {useRef} from "react";
import {FormattedMessage} from "react-intl";
import ReactToPrint from "react-to-print";
import html2canvas from "html2canvas";
import {jsPDF} from "jspdf";
import CertificateBg from "images/Certificate/certificate_bg.png";
import styles from "./index.module.scss";

function CertificatePopup({title, name, groupName}) {
  const printRef = useRef(null);

  const onClickDownload = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF("l", "mm", [297, 210]);
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${title}-수료증.pdf`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.print_content} ref={printRef}>
          <img alt="certificate bg" src={CertificateBg} />
          <div className={styles.text_box}>
            <h3 className={styles.title}>
              <FormattedMessage id="ID_CERTIFICATE_TITLE" />
            </h3>
            <h2 className={styles.user}>{name}</h2>
            <p className={styles.class}>{groupName}</p>

            <p className={styles.contents}>
              <FormattedMessage id="ID_CERTIFICATE_CONTENT" /> : {title}
            </p>
            <p className={styles.complete}>
              <FormattedMessage id="ID_CERTIFICATE_DEC" />
            </p>
          </div>
        </div>

        <div className={styles.btns}>
          <button className={styles.download} type="button" onClick={onClickDownload}>
            <FormattedMessage id="ID_CERTIFICATE_DOWNLOAD" />
          </button>
          <ReactToPrint
            trigger={() => (
              <button className={styles.print} type="button">
                <FormattedMessage id="ID_CERTIFICATE_PRINT" />
              </button>
            )}
            content={() => printRef.current}
          />
        </div>
      </div>
    </div>
  );
}

export default CertificatePopup;
